module.exports = __webpack_public_path__ + "assets/paid-268a33f65e1e0b0ed57da2634c46f86a.svg";